import { displayAdsLog } from '../../utils/debug';

export function addSlotToRecommendation(id) {
    if (document) {
        const slotElem = document.createElement('div');
        slotElem.setAttribute('slot', id);
        const containerElem = document.createElement('div');
        containerElem.setAttribute('id', id);
        slotElem.appendChild(containerElem);

        const recomWc = getRecomWebComponent();
        if (recomWc) {
            recomWc.appendChild(slotElem);
        }
    }
}

export const getRecomWebComponent = () => {
    const webComponent =
        document.querySelector('data-podlet-mlt') ||
        document.querySelector('data-podlet-recommend');
    displayAdsLog(`webComponent ${Boolean(webComponent)}`);
    return webComponent;
};
